export const googleReviewLink = "https://maps.app.goo.gl/nt2dkR2vvf48SLow9?g_st=awb";

export const averageRating = 4.9;

export const reviews = [
  {
    id: 1,
    name: "Trupti Salgaonkar",
    rating: 5,
    text: "Rustik Stay is a beautiful farmhouse designed with folk art elements, featuring charming Warli stencil work that adds a traditional touch. The attic (mezzanine floor) brought back childhood memories of a cozy treehouse, filled with soft toys and warmth. The above-ground plunge pool was clean and relaxing - just what we needed. Everything, from the lamps to the shower and AC, worked flawlessly. Thoughtful little details throughout the house added extra comfort. The food was delicious and homely. The caretaker was like a genie - warm, caring and always available at the beck of a call. A perfect monsoon getaway for peace, nature, and quiet moments. Truly a must-visit!",
    date: "1 month ago",
    avatar: "TS",
    location: "Verified Guest",
  },
  {
    id: 2,
    name: "Rekha Thakur-Talawdekar",
    rating: 5,
    text: "Homely environment, nice food, good hospitality - exactly the place where you can relax calmly. It was a wonderful birthday arrangement done for my niece. The villa's rustic charm combined with modern amenities made our stay memorable. The staff went above and beyond to ensure we had everything we needed. Thanks to the Rustic Villa Team for such an amazing experience!",
    date: "2 weeks ago",
    avatar: "RT",
    location: "Family Celebration",
  },
  {
    id: 3,
    name: "Vishakha Kadam",
    rating: 5,
    text: "Excellent stay with neat and clean bedding throughout. The view is absolutely awesome and the food tasted fantastic. The caretaker is very much appreciated and approachable - always ready to help with a smile. The villa offers the perfect blend of comfort and nature. The peaceful surroundings and well-maintained facilities made our weekend getaway truly special.",
    date: "3 weeks ago",
    avatar: "VK",
    location: "Weekend Getaway",
  },
];
